"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    flex-shrink: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      selected = _ref.selected,
      disabled = _ref.disabled;
  return {
    color: disabled ? theme.disabledColor : selected ? theme.selectedBalanceColor : theme.balanceColor,
    fontWeight: theme.balanceFontWeight,
    marginRight: theme.palette.gutter / 2 + 'px'
  };
};

var Balance = _styledComponents["default"].span(_templateObject(), function (props) {
  return base(props);
});

var _default = Balance;
exports["default"] = _default;